import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import SellerLayout from './SellerLayout';

const SellerCategoryList = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/api/seller/category/list-data', {
          withCredentials: true,
        });

        if (res.data && res.data.ok) {
          setShopName(res.data.shop_name || '');
          setCategories(Array.isArray(res.data.categories) ? res.data.categories : []);
        } else {
          alert(res.data?.error || '카테고리 목록을 불러오지 못했습니다.');
        }
      } catch (err) {
        const redirect = err?.response?.data?.redirect;
        const error = err?.response?.data?.error;

        if (redirect) {
          navigate(redirect, { replace: true });
          return;
        }

        alert(error || '카테고리 목록을 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  const handleDelete = async (id) => {
    const ok = window.confirm('삭제하시겠습니까?');
    if (!ok) return;

    try {
      const res = await axios.post(
        '/api/seller/category/delete-process',
        { id },
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setCategories((prev) => prev.filter((row) => row.id !== id));
        return;
      }

      alert(res.data?.error || '삭제에 실패했습니다.');
    } catch (err) {
      alert(err?.response?.data?.error || '삭제에 실패했습니다.');
    }
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loadingWrap}>
          <div>로딩중...</div>
        </div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.container}>
        <div style={styles.titleRow}>
          <h2 style={styles.title}>카테고리 목록</h2>

          <Link to="/seller/category/add" style={styles.addButton}>
            카테고리 추가
          </Link>
        </div>

        <div style={styles.tableWrap}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>이름</th>
                <th style={styles.th}>상위 카테고리</th>
                <th style={styles.th}>정렬 순서</th>
                <th style={styles.th}>생성일</th>
                <th style={styles.th}>관리</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((row) => (
                <tr key={row.id}>
                  <td style={styles.td}>{row.name}</td>
                  <td style={styles.td}>{row.parent_name}</td>
                  <td style={styles.td}>{row.sort_order}</td>
                  <td style={styles.td}>{row.created_at}</td>
                  <td style={styles.td}>
                    <Link
                      to={`/seller/category/edit?id=${row.id}`}
                      style={styles.editButton}
                    >
                      수정
                    </Link>
                    <button
                      type="button"
                      onClick={() => handleDelete(row.id)}
                      style={styles.deleteButton}
                    >
                      삭제
                    </button>
                  </td>
                </tr>
              ))}
              {categories.length === 0 && (
                <tr>
                  <td style={styles.emptyTd} colSpan={5}>
                    카테고리가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loadingWrap: {
    minHeight: '300px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  container: {
    padding: '0px',
  },
  titleRow: {
    marginTop: '20px',
    marginBottom: '30px',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
  },
  title: {
    margin: 0,
    fontWeight: 'bold',
  },
  addButton: {
    display: 'inline-block',
    background: '#0d6efd',
    color: '#fff',
    textDecoration: 'none',
    padding: '10px 14px',
    borderRadius: '6px',
    whiteSpace: 'nowrap',
  },
  tableWrap: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    border: '1px solid #dee2e6',
    background: '#fff',
  },
  th: {
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    textAlign: 'center',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  emptyTd: {
    border: '1px solid #dee2e6',
    padding: '20px',
    textAlign: 'center',
    color: '#666',
  },
  editButton: {
    display: 'inline-block',
    marginRight: '8px',
    padding: '6px 10px',
    background: '#ffc107',
    color: '#000',
    textDecoration: 'none',
    borderRadius: '4px',
    fontSize: '13px',
  },
  deleteButton: {
    padding: '6px 10px',
    background: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '13px',
    cursor: 'pointer',
  },
};

export default SellerCategoryList;